import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

function ScrollMagicCtrl() {
	this.$target = $('.js-scroll-fade')
	this.controller = new ScrollMagic.Controller()

	this.init()
}

ScrollMagicCtrl.prototype.init = function () {
	const self = this;
	this.$target.each(function (k, v) {
		let scene = new ScrollMagic.Scene({
			triggerElement: $(this).get(0),
			reverse: false,
			offset: -150
		})
			// .setPin('.js-scroll-fade')
			.setClassToggle($(this).get(0), 'is-animation')
			.addTo(self.controller);
	})
}

export default ScrollMagicCtrl